import React from 'react'
import { Box, Chip, Stack, Typography } from '@mui/material'

import { poolwerxColors } from '../../theme/colors'
import { splitMarkdownSections } from '../../utils/releases'
import { ReleaseBody } from './ReleaseBody'

export const PSC_PANEL_HEADING = 'PSC Notes'

interface PscNotesPanelProps {
  body: string
}

const PscNotesPanel: React.FC<PscNotesPanelProps> = ({ body }) => {
  const sections = React.useMemo(() => splitMarkdownSections(body), [body])
  const useGrid = sections.length > 0
  return (
    <Box sx={{ mt: 3, minWidth: 0, maxWidth: '100%' }}>
      <Stack direction="row" alignItems="center" spacing={0.75} sx={{ mb: 1 }}>
        <Typography
          sx={{
            color: poolwerxColors.grey[700],
            fontSize: '0.95rem',
            fontWeight: 700,
            letterSpacing: 0.4,
            textTransform: 'uppercase',
          }}
        >
          {PSC_PANEL_HEADING}
        </Typography>
        <Chip
          label="Internal"
          size="small"
          sx={{
            height: 18,
            fontSize: '0.62rem',
            fontWeight: 600,
            letterSpacing: 0.4,
            color: poolwerxColors.grey[700],
            backgroundColor: poolwerxColors.grey[300],
          }}
        />
      </Stack>
      <Box
        sx={{
          bgcolor: '#FAFAFA',
          border: '1px solid #E0E0E0',
          borderRadius: '8px',
          px: { xs: 1.75, sm: 2.25 },
          pt: 1.1,
          pb: 1.5,
          minWidth: 0,
          maxWidth: '100%',
          boxSizing: 'border-box',
        }}
      >
        {!useGrid ? (
          <ReleaseBody body={body} dense />
        ) : (
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
              columnGap: 2.5,
              rowGap: 1,
            }}
          >
            {sections.map((section) => (
              <Box
                key={section.heading || 'lead'}
                sx={section.heading ? undefined : { gridColumn: { md: '1 / -1' } }}
              >
                <ReleaseBody body={section.content} dense />
              </Box>
            ))}
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default PscNotesPanel
